// The terminal's WebSocket goes to the ROUTER's host, never to the service's host
// (nobgp/nobgp-router#339, #1668). A published service is on `<name>.nobgp.link`,
// which is a different site from this app: a WebSocket there is cross-site, and
// Safari blocks (Firefox partitions) the session cookie it needs. The router's host
// is same-site with the app, so the app's own login cookie authenticates it, and
// the router runs the same checks the service host would.
export function terminalSocketURL(routerBaseURL: string, serviceName: string): string {
  const base = routerBaseURL.replace(/\/+$/, '').replace(/^http(s?):\/\//, 'ws$1://')
  return `${base}/v1/terminal/${encodeURIComponent(serviceName.toLowerCase())}`
}
